const guiColors = {
    'motion-primary': '#ff9800',
    'motion-primary-transparent': '#ff9800e6',
    'motion-tertiary': '#f57c00',

    'looks-secondary': '#ff9800',
    'looks-transparent': '#ff980059',
    'looks-light-transparent': '#ff980026',
    'looks-secondary-dark': 'hsla(33, 100%, 50%, 1)',

    'extensions-primary': 'hsla(36, 100%, 55%, 1)',
    'extensions-tertiary': 'hsla(36, 100%, 40%, 1)',
    'extensions-transparent': 'hsla(36, 100%, 55%, 0.35)',
    'extensions-light': 'hsla(36, 100%, 85%, 1)',

    'drop-highlight': '#ffb74d'
};

const blockColors = {
    checkboxActiveBackground: '#ff9800',
    checkboxActiveBorder: '#f57c00'
};

export {
    guiColors,
    blockColors
};